/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import ArrowIcon from '../../../assets/images/catalogue/arrowIcon';
import ChargerModule from '../../../components/chargerModule';
import { DTOgetOrderDetailedData, ORDER_STATUS } from '../../../types/orders';
import OrderDetailsTabs from './Components/OrderDetailsTabs/OrderDetailsTabs';
import Tab1General from './Components/Tab1General/Tab1General';
import Tab2Products from './Components/Tab2Products/Tab2Products';
import Tab3Billing from './Components/Tab3Billing/Tab3Billing';
import errorMessage from '../../../utils/errorMessage';
import { getOrderDetailedData } from '../../../services/orders';
import LoaderDetailsTabs from './Components/LoaderDetailsTabs/LoaderDetailsTabs';
import Tab1Loader from './Components/LoaderDetailsTabs/Tab1Loader';
import { UploadPaymentLinkModal } from '../Components';
import { ICountryDetail } from '../../../types/countries';
import { getListOfCountriesByOfferedService } from '../../../utils/getCountries';
import Tab4Address from './Components/Tab4Address/Tab4Address';
import { getOrganizationConfigByOrganizationId } from '../../../services/suscription/configurations.service';
import { IOrganizationConfig } from '../../../types/product.configuration.types';
import { displayErrorNotification } from '../../../utils/displayNudosStandardNotifications';
import Tab5History from './Components/Tab5History/Tab5History';
import { IOrderHistory } from '../../../types/suscription/history.types';
import { getOrderHistory } from '../../../services/suscription/history.service';
import { OrderLastUpdate } from './Components/OrderLastUpdate/OrderLastUpdate';
import { buildCompleteOrderHistory, updateCalculatedOrderHistoryStatus } from '../../../utils/history';
import useInvoicesState from 'state/useInvoicesState';
import useResetData from 'hooks/useResetData';
import useCommentsState from '../../../state/useCommentsState';

import './OrderDetailsInternalCard.scss';

const OrderDetailInternalCard = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const { replace } = useHistory();
  const { state }: { state?: { initialTab?: number } } = useLocation();
  const {
    setOrderId,
    setOrganizationName,
    setPaymentAgreementDate,
    setPaymentAgreementDays,
    setHasActiveCredit,
    setIsPaymentAgreement,
    setInvoiceType
  } = useInvoicesState();
  const { resetOrderDataState } = useResetData();
  const { clearComments, setComments } = useCommentsState();
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState<boolean>(false);
  const [orderDetailedData, setOrderDetailedData] = useState<DTOgetOrderDetailedData>();
  const [savedOrganizationConfigs, setSavedOrganizationConfigs] = useState<IOrganizationConfig[]>([]);
  const [orderHistory, setOrderHistory] = useState<IOrderHistory[]>([]);
  const [shouldCombineHistory, setShouldCombineHistory] = useState<boolean>(true);
  const [uploadingCounter, setUploadingCounter] = useState<number>(0);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [temporalUrl, setTemporalUrl] = useState<string>();
  const [listOfCountries, setListOfCountries] = useState<ICountryDetail[]>();
  const organizationName = orderDetailedData?.generalData?.orgData?.organizationName || '';
  const organizationId = orderDetailedData?.generalData?.orgData?.organizationId;
  const shimpmentData = orderDetailedData?.generalData?.shipmentData;
  const orderStatusName = orderDetailedData?.statusName as ORDER_STATUS;
  const committedPaymentDate = orderDetailedData?.generalData?.paymentData?.committedPaymentDate || '';
  const organizationCreditDays = orderDetailedData?.generalData?.paymentData?.paymentAgreementDays || 0;
  const hasActiveCredit = orderDetailedData?.hasActiveCredit;

  const { initialTab = 0 } = state || {};
  const [selectedTabId, setSelectedTabId] = useState<number>(initialTab);

  const infoSideBar = { position: 'order' };
  const headerInfo = { title: 'Órdenes', subtitle: 'Compras- Detalle pedido' };
  const headerDetail = document.getElementById('headerdDetail');

  const returnAction = () => replace('/order/shopping');

  const updateOrderDetailsInternalCard = () => setUploadingCounter(uploadingCounter + 1);

  const handleChangeSelectedTabId = (newTabId: number) => setSelectedTabId(newTabId);

  const getOrderData = async (desactivateLodader?: boolean) => {
    if (!desactivateLodader) setLoadingData(true);
    try {
      const response = await getOrderDetailedData(orderId);
      if (response) setOrderDetailedData(response);
    } catch (error) {
      errorMessage();
    } finally {
      setLoadingData(false);
    }
  };

  const getOrganizationConfig = async () => {
    if (!organizationId) return;
    try {
      const response = await getOrganizationConfigByOrganizationId(organizationId);
      if (response) setSavedOrganizationConfigs(response);
    } catch (error) {
      displayErrorNotification({
        customJSXMessage: <>Error al obtener las configuraciones almacenadas de la organización</>
      });
    }
  };

  const retrieveOrderHistory = async () => {
    try {
      const response = await getOrderHistory(Number(orderId));
      if (response) {
        setOrderHistory(updateCalculatedOrderHistoryStatus(response));
        setShouldCombineHistory(true);
      }
    } catch (error) {
      displayErrorNotification({
        customJSXMessage: <>Error al obtener el historial de la orden</>
      });
    }
  };

  const updateWithoutLoaders = async () => {
    await getOrderData(true);
    await getOrganizationConfig();
    await retrieveOrderHistory();
  };

  const syncCommentsWithStore = () => {
    if (orderDetailedData?.orderComments) {
      setComments(orderDetailedData.orderComments);
    }
  };

  const changeStatusModalLink = () => setShowPaymentLinkModal(!showPaymentLinkModal);

  const orderDetailsTabsList = [
    {
      tabId: 0,
      tabName: 'General',
      tabComponent:
        orderDetailedData && !!orderDetailedData?.generalData ? (
          <Tab1General
            changeStatusModalLink={changeStatusModalLink}
            updateWithoutLoaders={updateWithoutLoaders}
            updateData={updateOrderDetailsInternalCard}
            updateWithLoaders={getOrderData}
            orderDetailedData={orderDetailedData}
          />
        ) : (
          <></>
        )
    },
    {
      tabId: 1,
      tabName: 'Envíos',
      tabComponent: (
        <Tab4Address
          orderDetailedData={orderDetailedData}
          updateWithoutLoaders={updateWithoutLoaders}
          updateWithLoaders={getOrderData}
        />
      )
    },
    {
      tabId: 2,
      tabName: 'Lista productos',
      tabComponent: orderDetailedData ? (
        <Tab2Products
          productsByReferenceList={orderDetailedData?.listProducts}
          updateOrderDetailsInternalCard={updateOrderDetailsInternalCard}
          organizationName={organizationName}
          organizationId={organizationId}
          savedOrganizationConfigs={savedOrganizationConfigs}
          orderId={orderId}
          updateWithoutLoaders={updateWithoutLoaders}
          orderStatus={orderDetailedData?.statusName}
          selectedTabId={selectedTabId}
          shimpmentData={shimpmentData}
        />
      ) : (
        <></>
      )
    },
    {
      tabId: 3,
      tabName: 'Facturación',
      tabComponent: orderDetailedData ? (
        <Tab3Billing
          updateOrderDetailsInternalCard={updateOrderDetailsInternalCard}
          updateWithoutLoaders={updateWithoutLoaders}
          orderDetailedData={orderDetailedData}
          listOfCountries={listOfCountries || []}
        />
      ) : (
        <></>
      )
    },
    {
      tabId: 4,
      tabName: 'Historial',
      tabComponent: orderStatusName ? (
        <Tab5History orderHistory={orderHistory} orderStatusName={orderStatusName} />
      ) : (
        <></>
      )
    }
  ];

  const setOrderData = () => {
    setOrderId(Number(orderId));
    setOrganizationName(organizationName);
    setPaymentAgreementDate(committedPaymentDate);
    setPaymentAgreementDays(organizationCreditDays);
    setHasActiveCredit(hasActiveCredit || false);
    setIsPaymentAgreement(!!committedPaymentDate || false);
    setInvoiceType('order');
  };

  useEffect(() => {
    setOrderData();
  }, [orderDetailedData]);

  useEffect(() => {
    getOrganizationConfig();
  }, [organizationId]);

  useEffect(() => {
    getOrderData();
  }, [uploadingCounter]);

  useEffect(() => {
    retrieveOrderHistory();
  }, [orderId]);

  useEffect(() => {
    if (!orderDetailedData || !shouldCombineHistory) return;
    setOrderHistory(buildCompleteOrderHistory(orderDetailedData, orderHistory));
    setShouldCombineHistory(false);
  }, [orderDetailedData, orderHistory, shouldCombineHistory]);

  useEffect(() => {
    updateWithoutLoaders();
  }, [resetOrderDataState]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    syncCommentsWithStore();
  }, [orderDetailedData?.orderComments]);

  useEffect(() => {
    getListOfCountriesByOfferedService(setListOfCountries);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      clearComments();
    };
  }, [clearComments]);

  useEffect(() => {
    setSelectedTabId(initialTab);
  }, [initialTab]);

  return (
    <div>
      <ChargerModule infoSideBar={infoSideBar} headerInfo={headerInfo}>
        <div id="orderDetailsInternalCard">
          {showPaymentLinkModal && (
            <UploadPaymentLinkModal
              orderData={{ id: '', orderId: Number(orderDetailedData?.orderId || '0') }}
              defaultLink={temporalUrl || orderDetailedData?.generalData?.paymentData?.paymentLink || ''}
              setShowPaymentLinkModal={setShowPaymentLinkModal}
              handleTemporalUrl={e => setTemporalUrl(e)}
            />
          )}
          <section id="headerdDetail" className="orderDetailsHeader">
            <div className="leftSection">
              <div className="returnArrow" onClick={returnAction}>
                <ArrowIcon fill="#070F21" />
              </div>
              {loadingData && (
                <>
                  <div className="orderReferenceAndShipmentsCount">
                    <div className="orderReference">
                      <div className="orderLoader animationLoader" />
                    </div>
                  </div>
                  <LoaderDetailsTabs />
                </>
              )}
              {orderDetailedData && !loadingData && (
                <>
                  <div className="orderReferenceAndShipmentsCount">
                    <div className="orderReference">Orden {orderDetailedData?.orderId}</div>
                    <div className="shipmentsCount">
                      Envíos {orderDetailedData?.numberOfShipments || '- Sin información'}
                    </div>
                  </div>
                  <OrderDetailsTabs
                    tabsList={orderDetailsTabsList}
                    selectedTabId={selectedTabId}
                    handleChangeSelectedTabId={handleChangeSelectedTabId}
                  />
                </>
              )}
            </div>
            {loadingData && (
              <div className="rightSection">
                <div className="orderStatus animationLoader" />
                <div className="orderDatesSkeletonLoader animationLoader" />
              </div>
            )}
            {orderDetailedData && !loadingData && (
              <div className="rightSection">
                {orderStatusName && <OrderLastUpdate statusName={orderStatusName} orderHistory={orderHistory} />}
              </div>
            )}
          </section>
          {loadingData && <Tab1Loader />}
          {orderDetailedData && !loadingData && (
            <section
              className="tabContent pt-6"
              style={{ height: `calc(100% - ${headerDetail?.clientHeight}px)`, overflow: 'auto' }}
            >
              {orderDetailsTabsList[selectedTabId]?.tabComponent}
            </section>
          )}
        </div>
      </ChargerModule>
    </div>
  );
};

export default OrderDetailInternalCard;
